import { ApiOrderTransaction, ApiSubwalletBalance } from '@api/interfaces';
import { calculateReservedPoints } from '@shared/utilities';

export const getReservedBalance = (
  booking: ApiOrderTransaction,
  balances: ApiSubwalletBalance[],
) => {
  const bookingBalances = balances.filter(
    (balance) => balance.bookingId === booking.id,
  );
  return calculateReservedPoints(bookingBalances);
};
